import { BannerTypeEnum } from 'config/constants/banner'
import { useRequest } from 'hooks/useRequest'
import { useEffect, useMemo, useState } from 'react'
import HomeService from 'services/HomeService'
import { useAppDispatch, useAppSelector } from 'state'
import { setHunnyPartner } from 'state/app/actions'
import { HunnyPartner } from './type'

export const useGetHunnyPartner = () => {
  const hunnyPartner = useAppSelector((state) => state.app.hunnyPartner)
  return hunnyPartner
}

export const useHunnyPartner = () => {
  const hunnyPartner = useGetHunnyPartner()
  const [isLoading, setIsLoading] = useState(false)
  const { execute } = useRequest()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (hunnyPartner?.length > 0) return
    setIsLoading(true)

    const fetch = async () => {
      const response = await execute(HomeService.getBannerList(BannerTypeEnum.MarkettingBanner))
      if (response?.data) {
        const hunnyPartnerInfo = response.data?.[BannerTypeEnum.MarkettingBanner]
        dispatch(setHunnyPartner({ data: hunnyPartnerInfo as unknown as HunnyPartner[] }))
      }
    }

    fetch()
    setIsLoading(false)
  }, [hunnyPartner])

  return useMemo(() => {
    return {
      isLoading,
      partners: hunnyPartner || [],
    }
  }, [hunnyPartner, isLoading])
}
